import { render, staticRenderFns } from "./ModalFormBRS.vue?vue&type=template&id=0dc47f04&scoped=true"
import script from "./ModalFormBRS.vue?vue&type=script&lang=js"
export * from "./ModalFormBRS.vue?vue&type=script&lang=js"
import style0 from "./ModalFormBRS.vue?vue&type=style&index=0&id=0dc47f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc47f04",
  null
  
)

export default component.exports